
import { Fragment } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import CTA from "./components/CTA";
import Features from "./components/Features";
import Footer from "./components/Footer";
import UserFlow from "./components/UserFlow";
import TargetGroups from "./components/TargetGroups";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero 
        title="Automatisierte Business Partner Leadgenerierung für dein Eqology Business"
        subtitle="KI-gestützte Technologie findet automatisch qualifizierte Leads im Gesundheitsbereich, die noch keine NEM-Produkte nutzen – perfekt für Omega-3, Vitamin D und weitere Premium-Supplements"
        ctaLabel="Jetzt kostenlos starten"
        ctaLink="/register"
      />
      <About />
      <TargetGroups />
      <UserFlow />
      <Features />
      <CTA />
      <Footer />
    </div>
  );
}
